// Resizes a File (from <input type="file">) to a JPEG data URL bounded by
// maxW × maxH while preserving aspect ratio. Quality defaults to 0.55.
// Throws if the file isn't an image or canvas encoding fails.
export async function resizeImageToDataURL(
  file: File,
  maxW = 600,
  maxH = 450,
  quality = 0.55,
): Promise<string> {
  if (!file.type.startsWith('image/')) {
    throw new Error('File is not an image');
  }
  const bitmap = await createImageBitmap(file);
  const ratio = Math.min(maxW / bitmap.width, maxH / bitmap.height, 1);
  const w = Math.round(bitmap.width * ratio);
  const h = Math.round(bitmap.height * ratio);
  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Could not get canvas context');
  ctx.drawImage(bitmap, 0, 0, w, h);
  bitmap.close?.();
  return canvas.toDataURL('image/jpeg', quality);
}
